import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../../constants/api';
import { useLanguage } from '../../contexts/LanguageContext';

const SECTION_LABELS = {
  leads: 'Leads',
  campaigns: 'Eventos',
  analytics: 'Analytics',
  integrations: 'Integraciones',
  hub: 'Hub',
  followups: 'Follow-ups',
  developer: 'Desarrollador',
  teams: 'Teams',
  team_analytics: 'Analítica de Equipo',
};
const sectionLabel = (key, t) => t(`adminDisabledSections.section.${key}`, SECTION_LABELS[key] || key);

// Global "coming soon" kill-switch per section — the section stays visible
// and browsable, but every real action inside shows "Muy pronto" instead of
// running (see ComingSoonOverlay). Different from plan gating: this isn't
// about who can see it, it's about the feature not being ready yet.
const AdminDisabledSectionsToggle = () => {
  const { t } = useLanguage();
  const [disabled, setDisabled] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const fetchStatus = async () => {
    try {
      const { data } = await axios.get(`${API}/settings/disabled-sections`);
      setDisabled(data.disabled_sections || []);
    } catch (error) {
      console.error('Error loading disabled sections:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStatus();
  }, []);

  const toggleSection = async (key) => {
    const next = disabled.includes(key) ? disabled.filter((s) => s !== key) : [...disabled, key];
    setSaving(true);
    try {
      const token = localStorage.getItem('token');
      await axios.put(
        `${API}/admin/settings/disabled-sections`,
        { sections: next },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setDisabled(next);
    } catch (error) {
      console.error('Error updating disabled sections:', error);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-white card-shadow-lg rounded-xl p-4 mb-6" style={{ maxWidth: 420 }}>
      <h3 className="text-sm font-semibold text-black mb-1">{t('adminDisabledSections.title', 'Secciones "Muy pronto"')}</h3>
      <p className="text-gray-500 text-xs mb-3">
        {t('adminDisabledSections.desc', 'La sección sigue visible pero sus botones muestran "Muy pronto" en vez de funcionar.')}
      </p>
      {loading ? (
        <p className="text-gray-400 text-xs">{t('adminDisabledSections.loading', 'Cargando...')}</p>
      ) : (
        <div className="space-y-1.5">
          {Object.keys(SECTION_LABELS).map((key) => {
            const isOff = disabled.includes(key);
            return (
              <div key={key} className="flex items-center justify-between gap-3 py-1">
                <span className="text-sm text-gray-700">{sectionLabel(key, t)}</span>
                <button
                  type="button"
                  role="switch"
                  aria-checked={isOff}
                  disabled={saving}
                  onClick={() => toggleSection(key)}
                  style={{
                    position: 'relative',
                    width: 34,
                    height: 20,
                    borderRadius: 980,
                    border: 'none',
                    background: isOff ? '#F59E0B' : '#D1D5DB',
                    cursor: saving ? 'not-allowed' : 'pointer',
                    opacity: saving ? 0.6 : 1,
                    transition: 'background .2s ease',
                    flexShrink: 0,
                  }}
                >
                  <span
                    style={{
                      position: 'absolute',
                      top: 2,
                      left: isOff ? 16 : 2,
                      width: 16,
                      height: 16,
                      borderRadius: '50%',
                      background: '#fff',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
                      transition: 'left .2s ease',
                    }}
                  />
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default AdminDisabledSectionsToggle;
